import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import {
  MdAdd,
  MdArrowForwardIos,
  MdBookmark,
  MdBookmarkBorder,
  MdCheckCircle,
  MdCloud,
  MdFolder,
  MdMenu,
  MdOutlineShoppingCart,
  MdPerson,
  MdPersonOutline,
  MdShoppingCart,
} from "react-icons/md";

import "../styles/Account.css";
import "../styles/Marketing.css";
import Spinner from "../components/Spinner";
import { useNavigate } from "react-router";
import { isEmpty } from "../functions/isEmpty";
import InstagramConnectButton from "../components/InstagramConnectButton";

export default function Marketing({
  apiURL,
  isMobile,
  chats,
  scrollPositionHome,
  setScrollPositionHome,
  operators,
  user,
  searchString,
  setSearchString,
  setActiveOperator,
  activeContact,
  setActiveContact,
  activeOperator,
  documents,
  files,
  setFiles,
  customers,
  messages,
  connections,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [marketingConnection, setMarketingConnection] = useState({});
  const [sortedData, setSortedData] = useState([]);
  let navigate = useNavigate();

  const handleClick = (chats_id, sendername) => {
    return;
    let searchedOperatorID = 0;
    let searchedOperator = {};
    if (!isEmpty(sendername)) {
      console.log(sendername);
      setActiveContact(sendername);
    }
    chats.map((chat, index) => {
      if (chat.id == chats_id) {
        searchedOperatorID = chat.operators_id;
      }
    });

    operators.map((operator, index) => {
      if (operator.id == searchedOperatorID) {
        searchedOperator = operator;
      }
    });
    setActiveOperator(searchedOperator);

    navigate("/chats/" + chats_id);
  };

  useEffect(() => {
    connections.map((conn, index) => {
      console.log(conn);

      if (conn.type == "instagram_basic" || conn.type == "instagram_business") {
        setMarketingConnection(conn);
        return;
      }
    });
  }, [connections]);

  useEffect(() => {
    const grouped = messages
      .filter(
        (msg) =>
          (msg.sender !== "ai" &&
            msg.sender !== "user" &&
            msg.type == "instagram_media") ||
          msg.type == "instagram_media_draft"
      )
      .reduce((map, msg) => {
        const key = msg.thirdparty_id; // statt msg.sender
        const ts = Number(msg.createdAt);
        const unseen = msg.seen === 0 ? 1 : 0;

        if (!map.has(key)) {
          map.set(key, { ...msg, notseencount: unseen, ts });
        } else {
          const prev = map.get(key);
          if (ts > prev.ts) {
            map.set(key, {
              ...msg,
              notseencount: prev.notseencount + unseen,
              ts,
            });
          } else {
            prev.notseencount += unseen;
          }
        }
        return map;
      }, new Map());

    const sorted = Array.from(grouped.values())
      .sort((a, b) => b.ts - a.ts)
      .map(({ ts, ...rest }) => rest);

    setSortedData(sorted);
  }, [messages]);

  function formatTimestamp(unixTimestamp) {
    // Überprüfe, ob der Timestamp eine gültige Zahl ist
    if (isNaN(unixTimestamp)) {
      return "";
    }

    const date = new Date(unixTimestamp * 1000); // Unix-Timestamp in Sekunden
    const now = new Date();

    // Prüfe, ob das Datum vom heutigen Tag ist
    if (date.toDateString() === now.toDateString()) {
      // Formatierung: hh:mm
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      return `${hours}:${minutes}`;
    }

    // Berechne den Unterschied in Tagen
    const startOfToday = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );
    const startOfDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );
    const diffTime = startOfToday - startOfDate;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    // Wenn genau 1 Tag Unterschied: "gestern"
    if (diffDays === 1) {
      return "Gestern";
    }

    // Liegt die Nachricht zwischen 1 und 6 Tagen zurück?
    if (diffDays < 7) {
      // Deutscher Wochentag
      const weekdays = [
        "Sonntag",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag",
      ];
      return weekdays[date.getDay()];
    } else {
      // Mehr als 7 Tage zurück: Format dd.mm.yy
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear().toString().slice(-2);
      return `${day}.${month}.${year}`;
    }
  }
  useEffect(() => {
    if (isEmpty(user)) {
      let authData = localStorage.getItem("@ditochat_user");
      if (!isEmpty(authData)) {
        navigate("/login");
      }
    }
    setActiveContact(null);
  }, [user]);

  const createNewMail = (operator) => {
    setActiveOperator(operator);
    chats.map((chat) => {
      if (chat.operators_id == operator.id) {
        navigate("/chats/" + chat.id);
      } else {
        navigate("/chats/0");
      }
    });
  };

  function extractMedia(input) {
    if (typeof input !== "string") {
      throw new TypeError("extractMedia ➜ expected a string");
    }

    // ---------- 1) Performance-Block abtrennen ----------
    //    erkennt "(12 Likes)", "(7 Kommentare)" oder "(12 Likes · 7 Kommentare)"
    var perfRegex =
      /\s*\(\s*(?:(\d+)\s+Likes?)?(?:\s*·\s*)?(?:(\d+)\s+Kommentare?)?\s*\)\s*$/i;

    var likes = null;
    var comments = null;
    var body = input.trim();

    var perfMatch = body.match(perfRegex);
    if (perfMatch) {
      if (perfMatch[1]) likes = parseInt(perfMatch[1], 10);
      if (perfMatch[2]) comments = parseInt(perfMatch[2], 10);
      body = body.replace(perfRegex, "").trimEnd(); // KPI-Teil entfernen
    }

    // ---------- 2) Caption & Media-URL trennen ----------
    var urlKey = "https://";
    var lastIdx = body.lastIndexOf(urlKey);

    var caption = body;
    var mediaUrl = "";

    if (lastIdx !== -1) {
      caption = body.slice(0, lastIdx).trimEnd();
      mediaUrl = body.slice(lastIdx).trim();
    }

    return {
      caption: caption,
      mediaUrl: mediaUrl,
      likes: likes,
      comments: comments,
    };
  }

  async function sendInstagramPost(usersId, mediaUrls) {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("users_id", usersId);
    formData.append("media_urls", JSON.stringify(mediaUrls)); // als JSON String

    try {
      const response = await fetch(
        "https://cloud.ditochat.com/api/skills/postOnInstagram.php",
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      setIsLoading(false);
      console.log("Erfolg:", result);
    } catch (error) {
      console.error("Fehler beim Senden:", error);
    }
  }

  const doNothing = () => {
    return;
  };

  return (
    <div className="marketing">
      <div className="marketing_topnav">
        <div className="marketing_topnav_headline">Social Media</div>
        <div className="home_topnav_menubtn" onClick={() => navigate("/menu")}>
          <MenuIcon />
        </div>
      </div>

      <div className="marketing_body">
        <div className="marketing_body_customers">
          {isEmpty(marketingConnection) && (
            <>
              <div className="inbox_connectbtn">
                <InstagramConnectButton user={user} mode="test" />
              </div>
              <div className="inbox_connectbtn">
                <InstagramConnectButton user={user} mode="live" />
              </div>
            </>
          )}
          {!isEmpty(marketingConnection) &&
            sortedData?.map((message, index) => (
              <div
                className="marketing_body_customers_element"
                key={"customers," + index}
                onClick={() => handleClick(message.chats_id, message.sender)}>
                <div className="marketing_body_customers_element_left">
                  <img
                    src={extractMedia(message.message).mediaUrl}
                    className="marketing_body_customers_element_left_img"
                  />
                </div>
                <div className="marketing_body_customers_element_right">
                  <div className="marketing_body_customers_element_top">
                    <div className="marketing_body_customers_element_top_left">
                      {extractMedia(message.message).caption}
                    </div>
                    <div className="marketing_body_customers_element_top_right">
                      {formatTimestamp(message.createdAt)}
                    </div>
                  </div>
                  <div className="marketing_body_customers_element_bottom">
                    <div className="marketing_body_customers_element_bottom_left">
                      {message.type == "instagram_media_draft" && (
                        <div
                          className="marketing_body_customers_element_bottom_left_btn"
                          onClick={() =>
                            isLoading
                              ? doNothing()
                              : sendInstagramPost(user.id, [
                                  extractMedia(message.message).mediaUrl,
                                ])
                          }>
                          {isLoading ? <Spinner /> : "Auf Insta posten"}
                        </div>
                      )}
                    </div>
                    <div className="marketing_body_customers_element_bottom_right">
                      {extractMedia(message.message).likes &&
                        extractMedia(message.message).likes + " likes"}
                      {extractMedia(message.message).comments &&
                        extractMedia(message.message).comments + " Kommentare"}
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}

const MenuIcon = styled(MdMenu)`
  font-size: 30px;
  color: #474747;
`;

const ArrowForwardIcon = styled(MdArrowForwardIos)`
  font-size: 15x;
  color: #bababa;
`;

const CloudIcon = styled(MdFolder)`
  font-size: 18px;
  color: #474747;
`;

const CheckIcon = styled(MdCheckCircle)`
  font-size: 25px;
  color: #0072f5;
`;

const AddIcon = styled(MdAdd)`
  font-size: 23px;
  color: #0072f5;
`;

const FolderIcon = styled(MdFolder)`
  font-size: 23px;
  color: rgb(114, 114, 114);
`;

const AccountIcon = styled(MdPerson)`
  font-size: 23px;
  color: rgb(114, 114, 114);
`;
